
import { i18nText } from '@/locales';

import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import { loyaltyBonusTabs } from '@/utils/tabs';
import { ITableColumn } from '@/entity/table/table.types';
import { TablesStore } from '@/store/modules/Tables';
import LoyaltyBonusTypeAddForm from '@/form/loyalty/loyaltyBonusType/LoyaltyBonusTypeAddForm';
import LoyaltyBonusTypeUpdateForm from '@/form/loyalty/loyaltyBonusType/LoyaltyBonusTypeUpdateForm';
import LoyaltyBonusTypeAddComponent from '@/UI/components/forms/loyalty/loyaltyBonus/loyaltyBonusType/LoyaltyBonusTypeAddComponent.vue';
import LoyaltyBonusTypeUpdateComponent from '@/UI/components/forms/loyalty/loyaltyBonus/loyaltyBonusType/LoyaltyBonusTypeUpdateComponent.vue';
import { LoyaltyBonusTypeStore } from '@/store/modules/LoyaltyBonusType';
import ModalWrapper from '@/UI/components/common/ModalWrapper.vue';
import {
    ILoyaltyBonusType,
    ILoyaltyBonusTypeListItem
} from '@/entity/loyalty/loyaltyBonus/loyaltyBonusType/LoyaltyBonusType.types';

@Component({
    components: { ModalWrapper, PageTitle, LoyaltyBonusTypeAddComponent, LoyaltyBonusTypeUpdateComponent }
})
export default class LoyaltyBonusType extends Vue {
    tabs = loyaltyBonusTabs;
    form = new LoyaltyBonusTypeAddForm();
    updateForm = new LoyaltyBonusTypeUpdateForm();
    counterparty: ILoyaltyBonusTypeListItem | null = null;
    searchText = '';
    searchInput: null;
    searchedColumn = '';
    showAddModal = false;
    showUpdateModal = false;
    filterData: any;
    pagination = {
        showSizeChanger: true,
        pageSize: 10,
        total: 10
    };

    constructor() {
        super();

        this.filterData = {
            limit: this.pagination.pageSize
        };
    }
    tabChanged(key: string): void {
        this.$router.push({ name: key });
    }

    customRow = (record: any) => {
        return {
            on: {
                click: (event: any) => {
                    console.log(event);
                    //this.$router.push({name: RouterNameEnum.SalonDetail, params: {id: record.id}})
                    alert('clicked');
                }
            }
        };
    };

    async created(): Promise<void> {
        await LoyaltyBonusTypeStore.fetchAll({ limit: this.pagination.pageSize });

        console.log(this.loyaltyBonusType);
    }

    get columns(): ITableColumn[] {
        return TablesStore.loyaltyBonusType;
    }

    get loyaltyBonusType(): ILoyaltyBonusType | null {
        return LoyaltyBonusTypeStore.loyaltyBonusTypes;
    }

    get loyaltyBonusTypeLoaded(): boolean {
        return true;
    }

    handleAddModal(visible: boolean): void {
        this.showAddModal = visible;
    }

    handleUpdateModal(visible: boolean): void {
        this.showUpdateModal = visible;

        // this.updateForm.setFormData(this.counterparty);
    }

    show(counterparty: ILoyaltyBonusTypeListItem): void {
        this.counterparty = counterparty;
        this.handleUpdateModal(true);
        //this.visible = true;
    }

    async submit(): Promise<void> {
        if (await this.form.submit(LoyaltyBonusTypeStore.create)) {
            await LoyaltyBonusTypeStore.fetchAll({ limit: this.pagination.pageSize });
            this.showAddModal = false;
            this.form = new LoyaltyBonusTypeAddForm();
        }
    }
    async updateSubmit(): Promise<void> {
        if (await this.updateForm.submit(LoyaltyBonusTypeStore.update)) {
            await LoyaltyBonusTypeStore.fetchAll({ limit: this.pagination.pageSize });
            this.showUpdateModal = false;
            // if(this.loyaltyBonusType && this.loyaltyBonusType.data){
            //   if(this.counterparty){
            //     for(let i = 0; i < this.loyaltyBonusType.data.length; i++){
            //       if(this.counterparty.id == this.loyaltyBonusType.data[i].id){
            //         this.counterparty = this.loyaltyBonusType.data[i];
            //         break;
            //       }
            //     }
            //   }
            // }
            this.updateForm = new LoyaltyBonusTypeUpdateForm();
        }
    }

    handleSearch(selectedKeys: any, confirm: any, dataIndex: any) {
        confirm();
        this.searchText = selectedKeys[0];
        this.searchedColumn = dataIndex;
    }

    handleReset(clearFilters: any) {
        clearFilters();
        this.searchText = '';
    }

    async handleTableChange(pagination: any, filters: any, sorter: any) {
        let skip = 0;
        let data = this.filterData;

        if (pagination && pagination.current > 0) {
            skip = (pagination.current - 1) * pagination.pageSize;
        }

        data.skip = skip;
        data.limit = pagination.pageSize;

        await LoyaltyBonusTypeStore.fetchAll(data);
    }
}
